import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, FileText, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SectionHeading, Watermark } from '../components/Section';
import { resources as fallbackResources } from '../data/mock';
import { getResources, uploadUrl } from '../lib/api';
import SEO from '../lib/SEO';

export default function Resources() {
  const [items, setItems] = useState(fallbackResources);
  useEffect(() => {
    (async () => {
      try {
        const data = await getResources();
        if (Array.isArray(data) && data.length) {
          setItems(
            data.map((r) => ({
              title: r.title,
              desc: r.description,
              meta: r.meta,
              href: uploadUrl(r.url),
            }))
          );
        }
      } catch {}
    })();
  }, []);
  return (
    <div className="font-sans-body">
      <SEO />
      <section className="relative overflow-hidden">
        <Watermark opacity={0.04} />
        <div className="container-aqc relative py-16 lg:py-20 text-center">
          <span className="eyebrow">Resources</span>
          <h1 className="mt-5 font-serif text-[2.4rem] sm:text-[3rem] leading-[1.08] font-semibold text-aqc-navy max-w-3xl mx-auto">
            Resources & <span className="italic text-aqc-red">Downloads.</span>
          </h1>
          <p className="mt-6 text-aqc-muted max-w-2xl mx-auto">
            Free downloads to help you plan your next quality programme.
          </p>
        </div>
      </section>

      <section className="py-12 bg-aqc-cream">
        <div className="container-aqc grid md:grid-cols-2 gap-5">
          {items.map((r, idx) => (
            <div key={r.title + idx} className="bg-white border border-aqc-line rounded-2xl p-6 flex gap-5 card-lift">
              <div className="h-14 w-14 rounded-xl bg-aqc-red/10 text-aqc-red flex items-center justify-center shrink-0">
                <FileText size={22} />
              </div>
              <div className="flex-1">
                <h3 className="font-serif text-xl text-aqc-navy">{r.title}</h3>
                <p className="mt-1.5 text-sm text-aqc-muted leading-relaxed">{r.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-[0.72rem] uppercase tracking-[0.14em] text-aqc-muted font-semibold">{r.meta}</span>
                  <a href={r.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-aqc-red font-semibold text-sm">
                    <Download size={14} /> Download
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="container-aqc mt-10 text-center text-aqc-muted">
          <strong className="text-aqc-navy">More resources coming soon.</strong>
          <p className="mt-1 text-sm">Publications, whitepapers, and case studies will appear here as we publish them.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container-aqc text-center">
          <h2 className="font-serif text-3xl text-aqc-navy">Prefer a curated brief?</h2>
          <div className="mt-6">
            <Link to="/contact"><Button className="bg-aqc-navy hover:bg-[hsl(var(--aqc-navy-2))] text-white h-11 px-6">Ask our team <ArrowRight size={16} className="ml-1" /></Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
